"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferralSourceImplantBrand_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var ReferralSourceImplantBrand_Factory = /** @class */ (function () {
    function ReferralSourceImplantBrand_Factory() {
    }
    ReferralSourceImplantBrand_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Name: model.Name,
            RecordId: model.RecordId,
        };
        return result;
    };
    ReferralSourceImplantBrand_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Name: model.Name,
            RecordId: model.RecordId,
        };
        return result;
    };
    return ReferralSourceImplantBrand_Factory;
}());
exports.ReferralSourceImplantBrand_Factory = ReferralSourceImplantBrand_Factory;
